import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MorningLayout from "../../morningLayout";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { useAppContext } from "context/AppContext";

type LayoutProps = {
    children: React.ReactNode;
};

const menuItems = [
    { label: "인터넷오더접수", path: "/customer/online-order" },
    { label: "운송장조회", path: "/customer/tracking" },
    { label: "청구서조회", path: "/customer/invoices" },
    { label: "청구서수정요청", path: "/customer/invoices-edit" },
    { label: "운송장 신청접수", path: "/customer/tracking-request" },
];

const CustomerLayout = ({ children }: LayoutProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isApp } = useAppContext();
    const responsive1200 = useMediaQuery(1200);

    const activeIndex = useMemo(() => {
        return menuItems.findIndex(
            item =>
                location.pathname === item.path ||
                (item.path === "/customer/invoices-edit" && location.pathname.startsWith("/customer/invoices-edit")),
        );
    }, [location.pathname]);

    return (
        <div className={`flex flex-col relative ${!isApp && "mt-[116px]"} flex-1`}>
            <MorningLayout>
                {!isApp && (
                    <>
                        {/* 1200 이상 */}
                        {!responsive1200 && (
                            <div className="flex absolute w-full h-[50px] bg-[rgba(21,34,65,0.85)] text-white justify-center">
                                {menuItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`w-[200px] p-2.5 flex items-center justify-center border-l border-gray-600 text-[17px] cursor-pointer ${
                                            activeIndex === index
                                                ? "bg-[#f4f4f4] text-[#0e0057] relative after:absolute after:bottom-[-1px] after:left-0 after:w-full after:h-[1px] after:bg-[#f4f4f4]"
                                                : "text-white"
                                        } ${index === menuItems.length - 1 ? "border-r" : ""}`}
                                        onClick={() => {
                                            if (location.pathname === item.path) {
                                                navigate(0);
                                            } else {
                                                navigate(item.path);
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
                <div className={`w-full ${!isApp && "mt-[50px]"} responsive1200:mt-0 flex flex-col flex-1`}>{children}</div>
            </MorningLayout>
        </div>
    );
};

export default CustomerLayout;
